import React, { useCallback } from 'react';
import clsx from 'clsx';

export function FilterButton({ value, label, onClick, isSelected, disabled }: any) {
  const handleButtonClick = useCallback(() => onClick(value), [value, onClick]);
  return (
    <button
      key={value}
      onClick={handleButtonClick}
      tabIndex={0}
      data-testid='filter-button'
      className={clsx(
        'relative py-2 px-3 w-full border-gray-30 disabled:opacity-50 bg-white',
        'focus:outline-none',
        'focus-visible:ring',
        'first:rounded-l-md',
        'last:rounded-r-md last:border-r',
        isSelected ? 'border-1 border-gray-40 bg-blue-5 z-10' : 'border'
      )}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

export function OldFilterButton({ value, label, onClick, isSelected, disabled }: any) {
  const handleButtonClick = useCallback(() => onClick(value), [value, onClick]);
  return (
    <button
      key={value}
      onClick={handleButtonClick}
      tabIndex={0}
      className={clsx(
        'relative font-effra text-black-default py-3 w-full border-gray-30 disabled:opacity-50',
        'focus:outline-none',
        'focus-visible:ring',
        'first:rounded-l-lg',
        'last:rounded-r-lg last:border-r',
        isSelected ? 'border-2 border-primary-500 bg-gold z-30' : 'border'
      )}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

export function FilterButtonGroup({ children, selected }: any) {
  return (
    <div
      data-testid='filter-button-group'
      className={clsx('rounded-lg flex items-center justify-between mb-6', !selected && 'border border-transparent')}
    >
      {children}
    </div>
  );
}

export function OldFilterButtonGroup({ children, selected }: any) {
  return (
    <div
      className={clsx('rounded-lg flex items-center justify-between mb-6', !selected && 'border border-transparent')}
    >
      {children}
    </div>
  );
}
